import s from "./Footer.module.scss";


const Footer = () => {

    return (
        <footer>
                <a className={s.logoFooter} href="#">
                    <img src="/atelier-de-la-villette/assets/logo_Villette.jpg" alt="Atelier de la Villette. Aller à l'accueil" />
                </a>
                <nav>
                    <ul>
                        <li>62 rue Petit, 75019 Paris</li>
                        <li>01 42 40 98 98</li>
                        <li><a href="https://www.avh.asso.fr/implantations/latelier-de-la-villette/contact" target="_blank">Contactez-nous</a></li>
                    </ul>
                </nav>
                <nav>
                    <ul>
                        <li><a href="https://www.avh.asso.fr/mentions-legales" target="_blank">Mentions légales</a></li>
                        <li><a href="https://www.avh.asso.fr/politique-des-cookies" target="_blank">Politique des cookies</a></li>
                        <li><a href="https://www.avh.asso.fr/charte-de-protection-des-donnees-personnelles" target="_blank">Charte de données personnelles</a></li>
                    </ul>
                </nav>
        </footer>
    )
}

export default Footer;